/**
 * Categorical palette shared by every chart on the dashboard and by the tables
 * that legend them, so a category keeps one colour wherever it appears.
 *
 * These are AntV's default `category10` values. They sit outside the Ant Design
 * theme, so a theme change will not move them — see DEVELOPER_TASKS.md.
 */
export const CHART_PALETTE = [
  "#5B8FF9",
  "#61DDAA",
  "#65789B",
  "#F6BD16",
  "#7262FD",
  "#78D3F8",
  "#9661BC",
  "#F6903D",
  "#008685",
  "#F08BB4",
];

export default CHART_PALETTE;
